module.exports = __webpack_public_path__ + "static/media/text.45f9fff6.svg";